import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~lookups/actions/shifts';

import { CompanyShift, Shift } from '../models';

interface State extends CommonState<Shift> {
  company_shifts: CompanyShift[];
}

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  company_shifts: [],
};

const slice = buildSlice<State, Shift>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
